module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Costada-Caparica-f7049ba14d765205f1507e35e0e77f44.jpg";